"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ClientConsoleStream = /*#__PURE__*/_createClass(function ClientConsoleStream(config) {
  var _this = this;
  _classCallCheck(this, ClientConsoleStream);
  /**
   * Write the log entry to the console
   * @param  {Object} rec Serializer wrapper for log structure, passed as part of the log config
   * @returns {undefined}
   */
  _defineProperty(this, "write", function (rec) {
    var timestamp = rec && rec['@timestamp'] || '';
    var url = rec && rec.req && rec.req.url || '';
    var message = rec && rec.err && rec.err.message || rec.msg || rec.description || JSON.stringify(rec).substring(0, 240);
    var _defaultMessageFormat = "".concat(timestamp, ": ").concat(url, " : ").concat(message, "....");
    var _verboseMessageFormat = JSON.stringify(rec);

    // -- Select the appropriate output format. Default is truncated at 240 characters
    var messageFormat = _this.verbose ? _verboseMessageFormat : _defaultMessageFormat;
    var logLevel = rec === null || rec === void 0 ? void 0 : rec.level;

    /* eslint-disable no-console */
    // log appSecLogger events as console.info
    if (rec.type === 'appsec_event') {
      console.info(messageFormat);
    } else if (logLevel === 'trace' || logLevel === 'debug') {
      console.log(messageFormat);
    } else if (logLevel === 'fatal' || logLevel === 'error' || logLevel === undefined) {
      console.error(messageFormat);
    } else {
      var _console;
      var logFn = (_console = console) === null || _console === void 0 ? void 0 : _console[logLevel];
      if (typeof logFn === 'function') {
        logFn(messageFormat);
      }
    }
    if (rec.err && rec.err.stack) {
      console.error(rec.err.stack);
    }
    /* eslint-enable no-console */
  });
  this.verbose = config.verbose || false;
});
var _default = exports.default = ClientConsoleStream;